export const initAssets = ['brand/anim/skeleton.json']
export const splashAssets = [
  'animations/spine/splash/skeleton.json',
  'animations/spine/fullscreen/skeleton.json',
  'brand/images/brand.png',
  'atlases/splash-0.json',
  'atlases/splash-1.json',
  'atlases/base-0.json',
]
export const assets = [
  'animations/spine/items/1/skeleton.json',
  'animations/spine/items/A/skeleton.json',
  'animations/spine/items/B/skeleton.json',
  'animations/spine/items/C/skeleton.json',
  'animations/spine/items/D/skeleton.json',
  'animations/spine/items/E/skeleton.json',
  'animations/spine/lines/skeleton.json',
  'animations/spine/logo/skeleton.json',
  'animations/spine/lowItems/skeleton.json',
  'animations/spine/mainSpine/skeleton.json',
  'animations/spine/mainSpine-sc/skeleton.json',
  'animations/spine/reels/chance/skeleton.json',
  'animations/spine/win/skeleton.json',
  'bitmap/bitmap.xml',
  'atlases/main-0.json',
  'atlases/main-1.json',
  'atlases/main-2.json',
]
export const particle = ['atlases/particle-0.json']
